export function updateTempColor(temp) {
  const colorIndex = temp;

  let tempColor;

  if (colorIndex <= -15) {
    tempColor = '#75165B';
  } else if (colorIndex > -15 && colorIndex <= -10) {
    tempColor = '#00417B';
  } else if (colorIndex > -10 && colorIndex <= -5) {
    tempColor = '#006E9F';
  } else if (colorIndex > -5 && colorIndex <= 0) {
    tempColor = '#28A5A7';
  } else if (colorIndex > 0 && colorIndex <= 5) {
    tempColor = '#6AB165';
  } else if (colorIndex > 5 && colorIndex <= 12) {
    tempColor = '#A0C300';
  } else if (colorIndex > 12 && colorIndex <= 20) {
    tempColor = '#F49500';
  } else if (colorIndex > 20 && colorIndex <= 25) {
    tempColor = '#F26D00';
  } else if (colorIndex > 25 && colorIndex <= 30) {
    tempColor = '#E74100';
  } else {
    tempColor = '#E90000';
  }
  return tempColor;
}
